import type { IconSvgObject } from './types';

const ChartMediumIcon: IconSvgObject = [
  ["path", { d: "M7 7C7.62858 5.87847 8.48131 5 9.79329 5C15.3402 5 12.2224 17 18.1831 17C19.5044 17 20.352 16.1157 21 15", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartMediumIcon;
